import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom"; 
import Footer from "../Components/Navigation/Footer";
import "../Pages/ProcessSales.css";
import "../Forms/BookValuation.css";
import arrowIcon from "../Assets/Images/arrowIcon.svg"; 
import Banner from "../Components/Banner";
import EstateBuilding from "../Assets/Images/AboutUs/brown-building-trees.jpeg";
import Navigation from "../Components/Navigation/Navigation";


function BookValuation() {
  const [valuationType, setValuationType] = useState("");


  useEffect(() => {
    document.title = "Request Valuation | Zen Homes";
  }, []);

  const [showDetailedInfo, setShowDetailedInfo] = useState(false);

  // Toggle detailed information visibility
  const toggleDetailedInfo = () => {
    setShowDetailedInfo((prev) => !prev);
  };

  const API_KEYS = {
    sales: process.env.REACT_APP_SALES_API_KEY,
    lettings: process.env.REACT_APP_LETTINGS_API_KEY,
  };

  const handleValuationTypeChange = (event) => {
    setValuationType(event.target.value);
  };

  const [result, setResult] = useState("");
  const navigate = useNavigate(); // For redirection
  const [showSuccessBanner, setShowSuccessBanner] = useState(false);

  const onSubmit = async (event) => {
    event.preventDefault();
    setResult("Sending....");

    const formData = new FormData(event.target);

    let selectedApiKey = API_KEYS.sales; // Default to Sales API
    if (valuationType === "Lettings") {
      selectedApiKey = API_KEYS.lettings;
    }
    formData.append("access_key", selectedApiKey);

    const firstName = formData.get("name");
    const lastName = formData.get("surname");
    const subject = `${valuationType} - Valuation | ${firstName} ${lastName}`;
    formData.append("subject", subject);

    const response = await fetch("https://api.web3forms.com/submit", {
      method: "POST",
      body: formData
    });

    const data = await response.json();

    if (data.success) {
      setResult("Form Submitted Successfully");
      event.target.reset();
      setShowSuccessBanner(true);

      setTimeout(() => {
        setShowSuccessBanner(false); // Hide banner after 2 seconds
        navigate("/"); // Redirect to another page
      }, 2000);
    } else {
      console.log("Error", data);
      setResult(data.message);
    }
  };

  return (
    <div className="bookValuationContainer">
       {/* Success Banner */}
       {showSuccessBanner && (
        <div className="success-banner">
          ✅ Form Submitted Successfully! Redirecting...
        </div>
      )}
      <Navigation linkColor="black" submenuColor="black" menuIconColor="black"/>
      <Banner title="Book Valuation" backgroundImage={EstateBuilding}/>
      

      <div className="valuationLayoutContainer">
        <form onSubmit={onSubmit} className="registerForm">
          {/* Personal Details Section */}
          <div className="topPartForm">
            <h1 className="formTitle">Your Details</h1>
            <select
              className="detailsInfo"
              aria-label="Title"
              name="Title"
            >
              <option value="">Title</option>
              <option value="Mr">Mr</option>
              <option value="Miss">Miss</option>
              <option value="Ms">Ms</option>
              <option value="Mrs">Mrs</option>
              <option value="Dr">Dr</option>
            </select>
            <input
              type="text"
              className="input"
              placeholder="First Name"
              aria-label="First Name"
              name="name"
              required
            />
            <input
              type="text"
              className="input"
              placeholder="Surname"
              aria-label="Surname"
              name="surname"
            required
            />
          </div>

          {/* Contact Details Section */}
          <h1 className="formTitle">Contact Details</h1>
          <div className="secondPartForm">
            <div className="firstColumn">
              <h6 className="subtitle">Address</h6>
              <input
                type="text"
                className="input"
                placeholder="House Number"
                aria-label="House Number"
                name="house number"
          required
              />
              <input
                type="text"
                className="input"
                placeholder="Address Line 1"
                aria-label="Address Line 1"
               name="address 1"
               required
              />
              <input
                type="text"
                className="input"
                placeholder="Address Line 2"
                aria-label="Address Line 2"
              name="address 2"
              />
              <input
                type="text"
                className="input"
                placeholder="Address Line 3 (Optional)"
                aria-label="Address Line 3"
                name="address 3"
              />
              <input
                type="text"
                className="input"
                placeholder="Town"
                aria-label="Town"
               name="town"
               required
              />
              <input
                type="text"
                className="input"
                placeholder="County"
                aria-label="County"
               name="county"
              />
              <input
                type="text"
                className="input"
                placeholder="Postcode"
                aria-label="Postcode"
                name="postcode"
              />
            </div>
            <div className="secondColumn">
              <h6 className="subtitle">Telephone/Email</h6>
              <input
                type="text"
                className="input"
                placeholder="Telephone"
                aria-label="Telephone"
              name="telephone"
              required
              />
              <input
                type="text"
                className="input"
                placeholder="Mobile Number"
                aria-label="Mobile Number"
              name="mobile number"
              />
              <input
                type="email"
                className="input"
                placeholder="Email Address"
                aria-label="Email Address"
                name="email address"
                required
              />
            </div>
          </div>

          {/* More Detailed Information Section */}
          <div className="detailedInformationHeader">
            <h1 className="formTitle">Provide More Information?</h1>
            <img
              src={arrowIcon}
              alt="Toggle arrow"
              className={`toggleArrow ${
                showDetailedInfo ? "arrowDown" : "arrowRight"
              }`}
              onClick={toggleDetailedInfo}
              aria-expanded={showDetailedInfo}
            />
          </div>

          {showDetailedInfo && (
            <div className="detailedInformation">
              <select
                className="valuationType"
                aria-label="Valuation Type"
                name="valuation type"
                onChange={handleValuationTypeChange} 
                required
              >
                <option value="">Valuation Type</option>
                <option value="Sales">Sales</option>
                <option value="Lettings">Lettings</option>
              </select>

              <select
                className="valuationTime"
                aria-label="When will you sell or let?"
                name="time to sell or let"
              >
                <option value="">When will you sell or let?</option>
                <option value="Immediately">Immediately</option>
                <option value="2months">Within 2 Months</option>
                <option value="2 - 4 Months">2 - 4 Months</option>
                <option value="4 - 6 Months">4 - 6 Months</option>
                <option value="6 - 12 Months">6 - 12 Months</option>
                <option value="12+ Months">12+ Months</option>
                <option value="Not sure">Not Sure</option>
              </select>

              <select
                className="propertyType"
                aria-label="Choose Property Type"
              name="property type"
              >
                <option value="">Property Type</option>
                <option value="House">House</option>
                <option value="Flat/Apartment">Flat/Apartments</option>
                <option value="Bungalow">Bungalow</option>
                <option value="Maisonette">Maisonette</option>
                <option value="Semi-Detached">Semi-Detached</option>
                <option value="Detached">Detached</option>
              </select>

              <select
                className="propertyStyle"
                aria-label="Property Style"
               name="property style"
              >
                <option value="">Property Style?</option>
                <option value="New Build">New Build</option>
                <option value="Modern">Modern</option>
                <option value="Stone Cottage">Stone Cottage</option>
                <option value="Farm">Farm</option>
                <option value="Townhouse">Town House</option>
                <option value="Purpose Built">Purpose Built</option>
                <option value="Other">Other</option>
              </select>

              <select
                className="propertyFloors"
                aria-label="Floors?"
                name="property floors"
              >
                <option value="">Floors?</option>
                <option value="1">1</option>
                <option value="2">2</option>
                <option value="3">3</option>
                <option value="4">4</option>
                <option value="5">5</option>
                <option value="6+">6+</option>
              </select>

              <select
                className="propertyBedrooms"
                aria-label="Bedrooms?"
               name="property bedrooms"
              >
                <option value="">Bedrooms?</option>
                <option value="1">1</option>
                <option value="2">2</option>
                <option value="3">3</option>
                <option value="4">4</option>
                <option value="5">5+</option>
              </select>

              <select
                className="propertyBathrooms"
                aria-label="Bathrooms?"
               name="property bathrooms"
              >
                <option value="">Bathrooms?</option>
                <option value="1">1</option>
                <option value="2">2</option>
                <option value="3">3</option>
                <option value="4">4+</option>
              </select>

              <select
                className="propertyGarages"
                aria-label="Garages?"
                name="property garages"
              >
                <option value="">Garages?</option>
                <option value="Yes">Yes</option>
                <option value="No">No</option>
              </select>

              <select
                className="propertyGarden"
                aria-label="Garden?"
            name="property garden"
              >
                <option value="">Garden?</option>
                <option value="Yes">Yes</option>
                <option value="No">No</option>
              </select>

              <select
                className="propertyParking"
                aria-label="Parking?"
                name="property parking"
              >
                <option value="">Parking?</option>
                <option value="Yes">Yes</option>
                <option value="No">No</option>
              </select>
            </div>
          )}
          
          <div class="h-captcha" data-captcha="true"></div>
          {/* Submit Button */}
      
          <div className="btnContainer">
            <button type="submit" className="submitBtn">
              Submit
            </button>
          </div>
        </form>
        <div>{result}</div>
      </div>

      <Footer />
    </div>
  );
}

export default BookValuation;
